module.exports = __webpack_public_path__ + "img/2025big2.5efde5d0.jpg";